import { useLocation } from "react-router-dom";
import { getPolicyByRoute } from "@/data/policyRegistry";
import PolicyView from "@/components/site/PolicyView";
import NotFound from "@/pages/NotFound";

export default function PolicyPage() {
  const { pathname } = useLocation();
  const policy = getPolicyByRoute(pathname);
  if (!policy) return <NotFound />;
  return <PolicyView policy={policy} />;
}

